import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  mutations: {
    SET_CART (state, payload) {
      state.cart = [...state.cart, payload].reduce(function(a, b) {
        var ean = b.ean, found = a.find(o => o.ean == ean)
        if (found) found.quantity += b.quantity
        else a.push(b)
        return a
      }, []).filter(product => product.quantity > 0)
    },
    REMOVE_CART (state, payload) {
      state.cart = state.cart.filter(product => product.ean !== payload.ean)
    },
    UPDATE_CART (state, payload) {
      state.cart = state.cart.map(product => {
        if (product.ean === payload.ean) {
          product.quantity = payload.quantity
        }
        return product
      })
    },
    SET_CATALOG (state, payload) {
      state.catalog = payload
    },
    SET_FILTER (state, payload) {
      state.filters[payload.key] = payload.value
    },
    SET_TAGS_BRAND (state, payload) {
      state.filters.tagsBrand = payload
    },
    SET_TAGS_COLORS (state, payload) {
      state.filters.tagsColors = payload
    },
    SET_TAGS_CATEGORIES (state, payload) {
      state.filters.tagsCategories = payload
    },
    SET_TAGS_BRACUP (state, payload) {
      state.filters.tagsBracup = payload
    },
    SET_FILTER_BY (state, payload) {
      state.filterBy = payload
    }
  },
  actions: {
    setCart ({commit}, payload) {
      commit('SET_CART', payload)
    },
    removeCart ({commit}, payload) {
      commit('REMOVE_CART', payload)
    },
    updateCart ({commit}, payload) {
      commit('UPDATE_CART', payload)
    },
    setCatalog ({commit}, payload) {
      commit('SET_CATALOG', payload)
    },
    setFilter ({commit}, payload) {
      commit('SET_FILTER', payload)
    },
    setTagsBrand ({commit}, payload) {
      commit('SET_TAGS_BRAND', payload)
    },
    setTagsColors ({commit}, payload) {
      commit('SET_TAGS_COLORS', payload)
    },
    setTagsCategories ({commit}, payload) {
      commit('SET_TAGS_CATEGORIES', payload)
    },
    setTagsBracup ({commit}, payload) {
      commit('SET_TAGS_BRACUP', payload)
    },
    setFilterBy ({commit}, payload) {
      commit('SET_FILTER_BY', payload)
    }
  },
  getters: {
    getCart: state => {
      return state.cart
    },
    getCatalog: state => {
      return state.catalog
    },
    getBrands: state => {
      return state.filters.brands
    },
    getCategories: state => {
      return state.filters.categories
    },
    getBracup: state => {
      return state.filters.bracup
    },
    getColors: state => {
      return state.filters.colors
    },
    getTagsBrand: state => {
      return state.filters.tagsBrand
    },
    getTagsColors: state => {
      return state.filters.tagsColors
    },
    getTagsCategories: state => {
      return state.filters.tagsCategories
    },
    getTagsBracup: state => {
      return state.filters.tagsBracup
    },
    getFilterBy: state => {
      return state.filterBy
    }
  },
  state: {
    filterBy: {
      where: '',
      what: ''
    },
    filters: {
      brands: [],
      categories: {},
      bracup: {},
      colors: [],
      tagsBrand: [],
      tagsColors: [],
      tagsCategories: [],
      tagsBracup: []
    },
    catalog: [],
    cart: []
  }
})
